export const RUOLI_LABEL: Record<string, string> = {
  SUPERADMIN: 'Superadmin',
  UTENTE:     'Operativo',
};

export function getRuoloLabel(ruolo: string): string {
  return RUOLI_LABEL[ruolo] ?? ruolo;
}
